import { PiCheckCircle, PiArrowRightLight } from 'react-icons/pi';
import { Bullet } from '../resourceContentUtils';

interface ArticleBulletsProps {
  bullets: Bullet[];
}

interface SubBulletProps {
  bullet: Bullet
}

const SubBullets = ({ bullet }: SubBulletProps) => {
  return(
  <ul className='list-none space-x2 m-0 p-0'> 
    {bullet.sub_bullet?.map((subBullet, index) => {
      const subBulletParts = subBullet.sub_bullet_text.split(":");

      return(
        <div className='flex items-center space-x-3' key={index}>
          <PiArrowRightLight className='text-primary h-4 w-4'/>
          <li className='prose w-full'>
            {subBulletParts.length > 1 ? (
              <>
                <strong>{subBulletParts[0]}:</strong>
                {subBulletParts.slice(1).join(':')}
              </>
            ) : (
              subBullet.sub_bullet_text
            )}
          </li>
        </div>
      )
    })}
  </ul>)
}

export const ArticleBullets = ({
  bullets,
}: ArticleBulletsProps) => {
  return (
    <ul className="space-y-2">
      {bullets.map((bullet, index) => {
        // Split the bullet text at the colon
        const parts = bullet.bullet_text.split(':');

        return (
          <div className="items-start space-x-2 flex" key={index}>
            <PiCheckCircle className="text-primary h-6 w-6 " />
            <li className="prose text-lg">
              {parts.length > 1 ? (
                <>
                  <strong>{parts[0]}:</strong>
                  {parts.slice(1).join(':')}
                </>
              ) : (
                bullet.bullet_text
              )}
              {bullet.sub_bullet && SubBullets({bullet})}
            </li>
          </div>
        );
      })}
    </ul>
  );
};
